export default __webpack_public_path__ + "static/media/icon_change_table.1f9e9dc0.jpg";